import { useEffect, useMemo, useState } from 'react';
import {
  MRT_EditActionButtons,
  MaterialReactTable,
  // createRow,
  type MRT_ColumnDef,
  type MRT_Row,
  type MRT_TableOptions,
  useMaterialReactTable,
} from 'material-react-table';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Tooltip,
} from '@mui/material';
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { AxiosInstance } from '../../api/apiInstance';
import { useSelector } from 'react-redux';
import { IUser } from '../../interface/IUser';
import { useParams } from 'react-router-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import { IproductLocation, IZone } from '../../interface/IProducts';
import { muiTableHeadCellPropsHelper } from '../../helper/helper';

// type  Props = {  
//   setSingleOrderData: ( SingleOrderData: IOrderHeader)  => void;
//   singleOrderData: IOrderHeader  ;
// }
function ProductLocations() {
  const { productId } = useParams();
  const userinfo: IUser = useSelector((state: any) => state.user)
  const [zoneInfo, setZoneInfo] = useState<IZone[]>([]);
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  const hiddenColumns = {
    id: false,
    linePhotoBase64: false,
    priority:  false,
  }


  useEffect(() => {
    async function GetData() {
      try {
        return await AxiosInstance({
          // url of the api endpoint (can be changed)
          url: "priority-products-locations/findZones",
          method: "GET",
        }).then((res) => {
          // handle success

          setZoneInfo(res.data)
        });
      } catch (e) {
        // handle error
        console.error(e);

      }
    }
    GetData();
  }, [])


  const columns = useMemo<MRT_ColumnDef<IproductLocation>[]>(
    () => [
      {
        accessorKey: 'id',
        header: 'id',
        enableEditing: false,
        Edit: () => null,

      },
       {
        accessorFn: (row) => row?.zone?.priority, //alternate way
        header: 'priority',
        enableEditing: false,  
        Edit: () => null,      

      },

      {
        accessorFn: (row) => row?.zone?.zoneName, //alternate way
        id: "zoneName", //id required if you use accessorFn instead of accessorKey
        header: "zone Name",
        size: 150,

        // Header: <i style={{ color: "red" }}>boxsize</i>, //optional custom markup
        editVariant: 'select',
        editSelectOptions:
          //boxInfo?.map(bx=> {return {value:bx.id , text: bx.sizeDesc}}),
          zoneInfo?.map(z => z.zoneName),

        muiEditTextFieldProps: {

          required: true,
          error: !!validationErrors?.zoneName,
          helperText: validationErrors?.zoneName,
          //remove any previous validation errors when Box focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              sizeDesc: undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },


      {
        accessorKey: 'location',
        header: 'location',
        size: 150,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.location,
          helperText: validationErrors?.location,
          //remove any previous validation errors when Box focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              location: undefined,
            }),
        },
      },
      {
        //accessorKey: "stockDate",
        accessorKey: 'stockDate',
        id: "stockDate", //id required if you use accessorFn instead of accessorKey
        header: "stock Date",
        size: 150,        
        muiEditTextFieldProps:({row}) => ({
          
          required: true,
          error: !!validationErrors?.stockDate,
          helperText: validationErrors?.stockDate,
          //remove any previous validation errors when Box focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              stockDate: undefined,
            }),
          type: 'date',
          //variant: 'outlined',
          InputLabelProps: {
            style: { top: '-1rem', fontWeight: '0.6rem' },

          },
          // inputProps: {
          //   style: { height: '1.5rem' },

          // },
          
        }),


      },
      {
        accessorFn: (row) => row?.quantity === 0 ? '' : row.quantity,
        accessorKey: 'quantity',
        header: 'quantity',
        size: 100,
      }

    ],
    [validationErrors],
  );

  const SaveProductLocation = async (productLocation: any) => {
    console.log('productLocation ', productLocation)

    const Req = {
      location: productLocation.location,
      stockDate: productLocation.stockDate,
      quantity: productLocation.quantity,
      zone: { id: zoneInfo.find((z) => { if (z.zoneName === productLocation.zoneName) return true; return false; })?.id },
      priorityProducts: { id: productId },
    }
    if (productLocation.id === undefined || productLocation.id === '') {
      await AxiosInstance.post('priority-products-locations/', Req)
        .then(function (response) {
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    else {
      await AxiosInstance.patch('priority-products-locations/' + productLocation.id, Req)
        .then(function (response) {
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    refetch();


  }


  const DeleteProductLocation = async (orderBoxesId: string) => {
    await AxiosInstance.delete('priority-products-locations/' + orderBoxesId)
      .then(function (response) {
      })
      .catch(function (error) {
        console.log(error);
      });
    refetch();

  }
  //CREATE action
  const handleCreateProductLocation: MRT_TableOptions<IproductLocation>['onCreatingRowSave'] = async ({
    values,
    table,
  }) => {
    console.log('ddddddddd',values)
    
    values.priority= zoneInfo.find((bo)=>{if(bo.zoneName === values.zoneName) return true;else return false;})?.priority ;        
    
    const newValidationErrors = validateProductLocation(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }
    setValidationErrors({});

    SaveProductLocation(values);
    table.setCreatingRow(null); //exit creating mode
  };

  //UPDATE action
  const handleSaveBox: MRT_TableOptions<IproductLocation>['onEditingRowSave'] = async ({
    row,
    values,
    table,
  }) => {
    console.log('handleSaveBox ', values, row.id, row._valuesCache.zone)
    values.id = row.id;
    //values.boxSize= boxInfo.find((bo)=>{if(bo.sizeDesc === values['sizeDesc']) return true;else return false;}) ;        
    const newValidationErrors = validateProductLocation(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }
    setValidationErrors({});

    //values.boxSize= boxInfo.find((bo)=>{if(bo.sizeDesc === values['sizeDesc']) return true;else return false;}) ;
    SaveProductLocation(values);
    table.setEditingRow(null); //exit editing mode
  };

  //DELETE action
  const openDeleteConfirmModal = (row: MRT_Row<IproductLocation>) => {
    if (window.confirm('Are you sure you want to delete this Product location?')) {
      DeleteProductLocation(row.original.id);
    }
  };

  const {
    data: fetchedData = [],
    isError: isLoadingError,
    isFetching: isFetching,
    isLoading: isLoading,
    refetch,
  } = useGetProductLocation();

  //READ hook (get Orders from api)
  function useGetProductLocation() {
    return useQuery<IproductLocation[]>({
      queryKey: ['priorityProductsLocations'],
      queryFn: async () => {
        //send api request here
        let tmpUrl = 'priority-products-locations/findAllByProduct/' + productId;
        return await AxiosInstance.get(
          tmpUrl,


        ).then((res) => {
          return res.data as IproductLocation[];
        });
      },
      refetchOnWindowFocus: 'always',
    });
  }


  const table = useMaterialReactTable({
    columns,
    data: fetchedData,
    createDisplayMode: 'modal', //default ('row', and 'custom' are also available)
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)
    enableEditing: true, //userinfo.userRoleName === 'Packer' || userinfo.userRoleName === 'Administrator'  || userinfo.userRoleName === 'QC' ? true : false,
    enableDensityToggle: false,
    initialState: { columnVisibility: hiddenColumns, density: 'compact' },
    enableHiding: false,
    enableColumnActions: false,
    enablePagination: false,

    enableSorting: false,
    enableBottomToolbar: false,
    enableColumnFilters: false,
    enableColumnOrdering: false,
    enableColumnFilterModes: false,
    enableFilterMatchHighlighting: false,
    enableGlobalFilter: false,
    enableFullScreenToggle: false,
    getRowId: (row) => row.id,
    // muiTableContainerProps: {
    //   sx: {
    //     minHeight: '300px',
    //   },
    // },
    muiTableHeadCellProps: {
      //no useTheme hook needed, just use the `sx` prop with the theme callback
      sx: (theme) => ({
        muiTableHeadCellPropsHelper
      }),
    },
    renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">Add Zone and Location</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    //optionally customize modal content
    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">Edit Box</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    muiTableBodyCellProps: ({ column }) => ({
      //conditionally style pinned columns
      sx: {
        fontWeight: '500',
        fontSize: '15px',
      },
    }),
    onCreatingRowCancel: () => setValidationErrors({}),
    onCreatingRowSave: handleCreateProductLocation,
    onEditingRowCancel: () => setValidationErrors({}),
    onEditingRowSave: handleSaveBox,
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Edit">
          <IconButton onClick={() => { table.setEditingRow(row) }}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    renderTopToolbarCustomActions: ({ table }) => (
      // <></>
      <div>
        <Tooltip arrow title="add">
          <IconButton onClick={() => table.setCreatingRow(true)}>
            <AddIcon />
          </IconButton>
        </Tooltip>
        <Tooltip arrow title="Refresh Data">
          <IconButton size="large" onClick={() => refetch()}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>


      </div>
    ),
    state: {
      isLoading: isLoading,
      //isSaving: isCreatingTask || isUpdatingTask || isDeletingTask,
      showAlertBanner: isLoadingError,
      showProgressBars: isFetching,
    },

  });

  return <MaterialReactTable table={table} />;
};


function validateProductLocation(productLocation: any) {
  console.log('urid',productLocation)
  return {
    Location: !validateRequired(productLocation.location)
      ? 'Location is Required'
      : '',
    zoneName: !validateRequired(productLocation.zoneName || '') ?
      'zoneName is  Required' : '',
    stockDate: !validateRequiredDateStock(productLocation.stockDate, productLocation.priority) ?
      'stockDate is  Required' : '',
  };
}

const queryClient = new QueryClient();

const ExampleWithProviders = () => (
  //Put this with your other react-query providers near root of your app
  <QueryClientProvider client={queryClient}>
    <Stack>
      <h2>Product Locations</h2>
      <ProductLocations />
    </Stack>
  </QueryClientProvider>
);

export default ExampleWithProviders;

const validateRequired = (value: string) => !!value.length;
const validateRequiredDateStock = (dt: any, priority: number) => {
  if (priority === 1) return true;
  if (dt === null || dt === '') return false;
  return true;
}





